import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';

import { ClienteCarteiraTipoPotencialBadgeComponent } from './potencial';
import { ClienteCarteiraTipoPretendidaBadgeComponent, ClienteCarteiraTipoPretendidaPercProgressComponent } from './pretendida';
import { ClienteCarteiraTipoProjetadaBadgeComponent, ClienteCarteiraTipoProjetadaPercProgressComponent } from './projetada';
import { ClienteCarteiraTipoRealizadaBadgeComponent, ClienteCarteiraTipoRealizadaPercProgressComponent } from './realizada';
import { ClienteCarteiraTipoPositivaEmpresaBadgeComponent } from './positiva-empresa';
import { ClienteCarteiraTipoPositivaRepresentanteBadgeComponent } from './positiva-representante';

import { ClienteCarteiraTipoPipe, ClienteCarteiraTipoAbreviacaoPipe } from './pipes';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        // Potencial
        ClienteCarteiraTipoPotencialBadgeComponent,

        // Pretendida
        ClienteCarteiraTipoPretendidaBadgeComponent,
        ClienteCarteiraTipoPretendidaPercProgressComponent,

        // Projetada
        ClienteCarteiraTipoProjetadaBadgeComponent,
        ClienteCarteiraTipoProjetadaPercProgressComponent,

        // Realizada
        ClienteCarteiraTipoRealizadaBadgeComponent,
        ClienteCarteiraTipoRealizadaPercProgressComponent,

        // Positiva Empresa
        ClienteCarteiraTipoPositivaEmpresaBadgeComponent,

        // Positiva Representante
        ClienteCarteiraTipoPositivaRepresentanteBadgeComponent,

        // Pipes
        ClienteCarteiraTipoPipe,
        ClienteCarteiraTipoAbreviacaoPipe
    ],
    exports: [
        SharedModule,

        // Potencial
        ClienteCarteiraTipoPotencialBadgeComponent,

        // Pretendida
        ClienteCarteiraTipoPretendidaBadgeComponent,
        ClienteCarteiraTipoPretendidaPercProgressComponent,

        // Projetada
        ClienteCarteiraTipoProjetadaBadgeComponent,
        ClienteCarteiraTipoProjetadaPercProgressComponent,

        // Realizada
        ClienteCarteiraTipoRealizadaBadgeComponent,
        ClienteCarteiraTipoRealizadaPercProgressComponent,

        // Positiva Empresa
        ClienteCarteiraTipoPositivaEmpresaBadgeComponent,

        // Positiva Representante
        ClienteCarteiraTipoPositivaRepresentanteBadgeComponent,

        // Pipes
        ClienteCarteiraTipoPipe,
        ClienteCarteiraTipoAbreviacaoPipe
    ],
    providers: [
        // Pipes
        ClienteCarteiraTipoPipe,
        ClienteCarteiraTipoAbreviacaoPipe
    ]
})
export class ClienteCarteiraTipoModule { }
